// extracted by mini-css-extract-plugin
export default {"wrap":"NF-z","fullWidth":"OF-z","hideOnDesktop":"PF-z","content":"QF-z","hasOpenedNav":"RF-z","crumbsList":"SF-z","dropdownsWrap":"TF-z"};